// extracted by mini-css-extract-plugin
export default {"footer":"ActionButton_footer__vIJVB","button":"ActionButton_button__6GjdH","left-button":"ActionButton_left-button__8+au7","right-button":"ActionButton_right-button__2cpNp"};